import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import get from "lodash/get";
import PlainComponent from '../../components/plain/PlainComponent';
import builder from '../builder';
export function render(node, path) {
    if (!node.Content)
        return null;
    var Content = node.Content, Children = node.Children;
    var type = Content.type, props = Content.props, label = Content.label;
    var componentKey = get(Content, 'props.componentKey', get(Content, 'componentKey', undefined));
    var spots = null;
    if (Children)
        spots = builder(path, Children, null, null, path + '/Children');
    var childData = {
        type: type,
        props: props,
        label: label,
    };
    return (_jsx(PlainComponent, { componentKey: componentKey, childProps: childData, spots: spots }, componentKey));
}
